import physio from "../../Assets/physio.png"
import spans1 from "../../Assets/spans1.png"
import spans2 from "../../Assets/spans2.png"
import spans3 from "../../Assets/spans3.png"
import spans4 from "../../Assets/spans4.png"
import spans5 from "../../Assets/spans5.png"
import spans6 from "../../Assets/spans6.png"
import spans7 from "../../Assets/spans7.png"
import spans8 from "../../Assets/spans8.png"
import apart1 from "../../Assets/apart1.png"
import apart2 from "../../Assets/apart2.png"
import apart3 from "../../Assets/apart3.png"
import apart4 from "../../Assets/apart4.png"
import rupesh from "../../Assets/rupesh.png"
import giri from "../../Assets/giri.png" 
import adithyaLogo from "../../Assets/hs1.png"
import kamalaLogo from "../../Assets/hs2.png"
import novacareLogo from "../../Assets/hs3.png"


export const serviceShowcaseData = [
  {
    imgSrc: physio,
    title: `Your Home,\n Our Clinic \n Let’s Start Your Recovery Journey`,
    buttonText: "Book Now",
    onButtonClick: () => console.log("Button Clicked"),
  }
]

export const heading1 = `Rehab Where You Relax`;
export const paragraph1 = `Our skilled therapists bring personalized care tailored to your needs, ensuring you can focus on healing while enjoying the \n convenience of your own space. Say goodbye to the hassle of clinic visits and hello to rehabilitation in the comfort of your \n own home, where you can truly unwind. Our holistic approach to care ensures convenience \n from consultation to treatment to post-operative care`;

export const spansHeading = `Our Expertise Spans Across`;
export const spansacross = {

  o1: { title: "Orthopedic Care", img: spans1 },
  o2: { title: "Geriatric Care", img: spans2 },
  o3: { title: "Sports Injuries", img: spans3 },
  o4: { title: "Neurologic Care", img: spans4 },
  o5: { title: "Spinal Care", img: spans5 },
  o6: { title: "Surgical Rehabilitation", img: spans6 },
  o7: { title: "Chronic Pain Rehabilitation", img: spans7 },
  o8: { title: "Ergonomic Therapy", img: spans8 },

}

export const physioSectionData = {
  heading: `Revitalize In Your Space`,
  paragraph: `Our expert therapists curate a personalized wellness journey
     tailored to your unique needs and surroundings. Whether you're recovering 
     from an injury, managing chronic pain, or seeking to enhance your mobility, 
     we're here to guide you towards optimal health and vitality. We utilize a 
     range of methods including physical therapy, patient education, and 
     specialized modalities to expedite patient recovery.`
}

export const UsApartHeading = `What Sets Us Apart`;

export const UsAPartParagraph = `"With a wealth of expertise and experience in diverse physiotherapy techniques and specialties, \n we help people recuperate and recover from pain effectively."`;

export const UsApart = {
  o1: { title: "Proven Methodologies", img: apart1 },
  o2: { title: "Individualized Care", img: apart2 },
  o3: { title: "Patient-Centric Approach", img: apart3 },
  o4: { title: "Internationally Accepted MOO", img: apart4 },
}

export const physioData = [
  {
    title: `Find Out Why We’re Buzzing`,
    desc: `Wihan physiotherapy services have been a lifesaver for my elderly
mother. She feels more at ease in her own home, and the progress
she's made is incredible. Thank you`,
    userimg: giri,
    username: "Giri Mohan"

  },
  {

    title: `Find Out Why We’re Buzzing`,
    desc: `After my surgery, I struggled with mobility, but thanks to Wihan
physiotherapy services, I'm regaining strength faster than I ever
imagined. It's been a game-changer`,
    userimg: rupesh,
    username: "Rupesh Kumar"
  },
  {

    title: `Find Out Why We’re Buzzing`,
    desc: `After my surgery, I struggled with mobility, but thanks to Wihan
physiotherapy services, I'm regaining strength faster than I ever
imagined. It's been a game-changer`,
    userimg: rupesh,
    username: "Rupesh Kumar"
  },
]

export const endorsedData = [
  { name: 'SHRI ADITHYA Hospitals', logo: adithyaLogo },
  { name: 'SRESHTA SRI KAMALA HOSPITALS', logo: kamalaLogo },
  { name: 'NOVACARE HOSPITALS', logo: novacareLogo },
];

export const settings3 = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,        
  autoplaySpeed: 3000,   
  arrows: false,
  responsive: [
    {
      breakpoint: 1200,
      settings: { slidesToShow: 3 }
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 3 }
    },
    {
      breakpoint: 480,
      settings: { slidesToShow: 2 }
    },
    {
      breakpoint: 380,
      settings: { slidesToShow: 1 }
    }
  ]
};